import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/compound-growth-calculator',
  component: () => import('../../routes/CompoundGrowthCalculator.svelte'),
  card: {
    id: 'compound-growth-calculator',
    title: 'Compound Growth Calculator',
    description: 'See how your money grows with compound interest over time, supporting multiple compounding frequencies and year-by-year breakdowns.',
    icon: 'trending_up',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/compound-growth-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Compound Growth Calculator – See Your Money Grow Over Time',
    description: 'Free compound growth calculator that shows how compound interest makes your money grow over time. Supports daily, monthly, quarterly, and annual compounding with year-by-year breakdowns.',
  },
};

export default meta;